import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { volumes } from '../data/volumes';
export function TomosSection() {
  return <section className="bg-blush px-4 py-20 sm:py-28" data-id="element-223" data-mp="1p3k4qsqwgh4f">
      <div className="mx-auto max-w-6xl" data-id="element-224" data-mp="1p43o8dw77dkk">
        <div className="mx-auto max-w-3xl text-center" data-id="element-225" data-mp="1u2na6easkpcx">
          <p className="text-sm font-bold uppercase tracking-[0.16em] text-raspberry" data-id="element-226" data-mp="1u257aytmjcw1">
            The teaching library
          </p>
          <h2 className="mt-3 font-serif text-4xl font-semibold leading-tight text-espresso sm:text-5xl" data-id="element-227" data-mp="xeqsf63mbo04">
            6 Complete Volumes in One Teaching System
          </h2>
          <p className="mt-4 text-base leading-7 text-cocoa" data-id="element-228" data-mp="16brakv03gpv4">
            Six specialized resources. One complete solution.
          </p>
        </div>
        <div className="mt-14 grid gap-6 md:grid-cols-2" data-id="element-229" data-mp="2hsr4fv23bcr9">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`flex h-full flex-col rounded-2xl border border-champagne bg-cream-light p-6 shadow-sm sm:p-8 ${volume.wide ? 'md:col-span-2' : ''}`} data-id="element-230" data-mp="2mqj63gsjed8n" data-mpi={index}>
              <p className="text-xs font-bold uppercase tracking-[0.15em] text-raspberry" data-id="element-231" data-mp="27qnvuetraxz3">
                {volume.number}
              </p>
              <h3 className="mt-2 font-serif text-2xl font-semibold leading-snug text-espresso sm:text-3xl" data-id="element-232" data-mp="1ywsy3ruys9th">
                {volume.title}
              </h3>
              {volume.subtitle && <p className="mt-2 text-sm font-bold uppercase tracking-[0.12em] text-champagne-deep" data-id="element-233" data-mp="1oylltmbmefxt">
                  {volume.subtitle}
                </p>}
              <div className={volume.wide ? 'mt-6 grid gap-8 md:grid-cols-2' : 'mt-6'} data-id="element-234" data-mp="1k24n5y6soj6h">
                <div data-id="element-235" data-mp="1fcaown07aki2">
                  <h4 className="text-xs font-bold uppercase tracking-[0.13em] text-cocoa" data-id="element-236" data-mp="1fckdc65lkjln">
                    Includes
                  </h4>
                  <ul className={`mt-3 grid gap-x-6 gap-y-2.5 ${volume.wide ? '' : 'sm:grid-cols-2'}`} data-id="element-237" data-mp="15ctl6b4iegoq">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex gap-2.5 text-sm leading-6 text-cocoa" data-id="element-238" data-mp="1y1h625lcj41r">
                        <CheckCircle2Icon size={17} className="mt-0.5 shrink-0 text-champagne-deep" aria-hidden="true" data-id="element-239" data-mp="1k89g0icwygm6" />
                        {bullet}
                      </li>)}
                  </ul>
                </div>
                {volume.extra && <div data-id="element-240" data-mp="5bgbcqy1k5gb">
                    <h4 className="text-xs font-bold uppercase tracking-[0.13em] text-cocoa" data-id="element-241" data-mp="5awt194hbf1r">
                      {volume.extraLabel}
                    </h4>
                    <ul className="mt-3 flex flex-wrap gap-2" data-id="element-242" data-mp="f1riemd0uurf">
                      {volume.extra.map(item => <li key={item} className="rounded-full border border-blush-line bg-blush px-3 py-1 text-xs font-medium text-espresso" data-id="element-243" data-mp="a4rhsqyxyk7p">
                          {item}
                        </li>)}
                    </ul>
                  </div>}
              </div>
              <div className="mt-auto pt-7" data-id="element-244" data-mp="3nhb7d96ntr0o">
                {volume.flow && <div className="rounded-xl border border-champagne bg-champagne-light px-4 py-3" data-id="element-245" data-mp="17qf60ol8tw85">
                    <p className="text-[11px] font-bold uppercase tracking-[0.13em] text-cocoa" data-id="element-246" data-mp="12rvgyfbcs4bk">
                      Visual flow
                    </p>
                    <p className="mt-1 text-sm font-bold tracking-wide text-espresso" data-id="element-247" data-mp="3dg0llhddri5s">
                      {volume.flow}
                    </p>
                  </div>}
                {volume.comparisons && <div className="rounded-xl border border-champagne bg-champagne-light px-4 py-3" data-id="element-248" data-mp="3mhrtmsve812t">
                    <p className="text-[11px] font-bold uppercase tracking-[0.13em] text-raspberry" data-id="element-249" data-mp="3reqmz978g3zy">
                      100% Visual — teach the difference
                    </p>
                    <ul className="mt-2 space-y-1.5" data-id="element-250" data-mp="4zp4xut9n8bj">
                      {volume.comparisons.map(item => <li key={item} className="text-sm font-bold tracking-wide text-espresso" data-id="element-251" data-mp="90r46bn6nkdi">
                          {item}
                        </li>)}
                    </ul>
                  </div>}
                {volume.result && <div className="rounded-xl border border-champagne bg-champagne-light p-4 text-sm leading-6 text-espresso" data-id="element-252" data-mp="o4tyfhs88nrp">
                    <strong className="font-semibold text-raspberry" data-id="element-253" data-mp="j4z6rc0mnu5l">
                      Result:{' '}
                    </strong>
                    {volume.result}
                  </div>}
              </div>
            </motion.article>)}
        </div>
        <div className="mx-auto mt-16 max-w-3xl border-t border-champagne pt-10 text-center" data-id="element-254" data-mp="16vlgd7qa5mhp">
          <h3 className="font-serif text-3xl font-semibold text-espresso sm:text-4xl" data-id="element-255" data-mp="124d3g1pqrizs">
            One System. Six Complete Volumes.
          </h3>
          <p className="mt-4 text-base leading-7 text-cocoa" data-id="element-256" data-mp="y2i4v4z73jpp">
            Instead of buying separate resources for cakes, doughs, croissants,
            chocolate, decoration and lesson planning, everything works together
            inside one complete system.
          </p>
        </div>
      </div>
    </section>;
}